import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import en from '../../../i18n/merged/en.json';
import es from '../../../i18n/merged/es.json';
import fr from '../../../i18n/merged/fr.json';
import pt from '../../../i18n/merged/pt.json';

const BUNDLES: Record<string, TranslationObject> = {
	pt: pt as TranslationObject,
	en: en as TranslationObject,
	es: es as TranslationObject,
	fr: fr as TranslationObject
};

/**
 * Carrega traduções já mescladas em build-time (sem N requests HTTP).
 * Fonte editável continua em src/i18n/**; rode `npm run i18n:merge` após alterar.
 */
export class AppTranslateLoader implements TranslateLoader {
	getTranslation(lang: string): Observable<TranslationObject> {
		return of(BUNDLES[lang] ?? BUNDLES['pt']);
	}
}
